export default __webpack_public_path__ + "static/media/533.8c0715f5.png";